// @ts-nocheck
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
import breakpointValues, { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
const titleStyles = (breakpoints: Array<Amount | null>) => css`
    ${spacingStyles("1em", "0.5em")}
    ${breakpointValues(pxToRemArray(breakpoints), "font-size")}
    ${({ theme }) => `
        font-family: ${theme.design.typography.fontFamily.title};
        font-weight: ${theme.design.typography.weight.black};
    `}
`;
/* Store Custom Code - End */

const typography: Styleguide["typography"] = {
    fontFamilyImportUrl: `${constants.path.fonts}/common.css` /* Store Custom Code */,
    body: {
        size: "inherit",
        weight: "inherit",
        fontFamily: "inherit",
        css: css`
            color: ${getColor("text")};
            font-style: normal;
            text-transform: none;

            ${({ theme }) => `
                font-family: ${theme.design.typography.fontFamily.base};
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.base};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: spacingStyles(),
    },
    h1: {
        css: css`
            ${titleStyles([48, 48, 48, 48, 48])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h2: {
        css: css`
            ${titleStyles([22, 22, 22, 22, 22])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h3: {
        css: css`
            ${titleStyles([20, 20, 20, 20, 20])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h4: {
        css: css`
            ${titleStyles([18, 18, 18, 18, 18])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h5: {
        css: css`
            ${titleStyles([16, 16, 16, 16, 16])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h6: {
        css: css`
            ${titleStyles([14, 14, 14, 14, 14])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    legend: {
        size: "inherit",
        weight: "inherit",
        color: null as any,
        transform: null as any,
        css: css`
            color: ${getColor("text.main")};
            margin-bottom: ${pxToRem(1)};
            text-transform: uppercase;

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.tiny}; /* Store Custom Code */
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.base};
            `};

            &&& + ${FormInputWrapper}, &&& + ${FormFieldStyle} {
                margin-top: ${pxToRem(2)};
            }
        `,
    },
    bannerText: {
        css: css`
            ${({ theme }) => css`
                ${breakpointValues(
                    [null, null, theme.design.typography.size.large, null, theme.design.typography.size.larger],
                    "font-size",
                )}
                ${breakpointValues(pxToRemArray([24, null, null, null, 30]), "margin-bottom")}
                line-height: ${theme.design.typography.lineHeight.semi};

                &:last-child {
                    margin-bottom: 0;
                }
            `}
        `,
    },
};

typography.bannerTitle = {
    ...typography.h1,
    forwardAs: "h1",
    css: css`
        ${typography.h1?.css}
        ${breakpointValues(pxToRemArray([16, null, null, null, 20]), "margin-bottom")}
    `,
};

typography.bannerSecondaryTitle = {
    ...typography.h2,
    forwardAs: "h1",
    css: css`
        ${typography.h2?.css}
        ${breakpointValues(pxToRemArray([16, null, null, null, 20]), "margin-bottom")}
    `,
};

export default typography;
